import AppDao from '../../../../../data/AppDao';
import Assembler from '../../../../../data/Assembler';
import { useCallback, useState } from 'react';
const debug = process.env.REACT_APP_DEBUG && false;
/** Override userFunctions.addObjectsToState for custom behavior eg where consuming component does not get objects from AppState */
export const useDatastorePersistForDataGrid = (userFunctions) => {
    'use no memo';
    // Error: Hooks must be called at the top level in the body of a function component or custom hook, and may not be called within function expressions.
    // Cannot call useCallback within a function expression.
    const [snackbar, setSnackbar] = useState(null);
    // https://mui.com/x/react-data-grid/editing/#persistence
    const useMutation = () => {
        return useCallback((newVob, oldVob) => new Promise(async (resolve, reject) => {
            const oldInstance = Assembler.getInstance(oldVob);
            if (oldInstance) {
                const persistRes = await AppDao.save(Object.assign(oldVob, newVob));
                if (persistRes.data) {
                    resolve(persistRes.data);
                    if (userFunctions) {
                        userFunctions.addObjectsToState([persistRes.data]);
                    }
                }
                else {
                    reject(new Error(persistRes.err?.message ?? 'Error, but nothing in save error from backend'));
                }
            }
            else {
                reject(new Error('Error while saving user: Could not create instance'));
            }
        }), []);
    };
    const mutateRow = useMutation();
    const processRowUpdate = useCallback(async (newRow, oldRow) => {
        debug && console.log(`DocClientDataGrid processRowUpdate`, { newRow, oldRow });
        // Make the HTTP request to save in the backend
        const response = await mutateRow(newRow, oldRow);
        setSnackbar({ children: `${newRow.name ?? newRow.type} successfully saved`, severity: 'success' });
        return response;
    }, [mutateRow]);
    const onProcessRowUpdateError = useCallback((error) => {
        setSnackbar({ children: error.message, severity: 'error' });
    }, []);
    return {
        snackBarState: [snackbar, setSnackbar],
        processRowUpdate,
        onProcessRowUpdateError,
    };
};
